/**
 * Search schemas — global Cmd+K palette (GET /v1/search).
 *
 * One group per entity type; `href` is the app's existing detail/list page
 * path for the entity so the palette can navigate straight to it.
 */

import { z } from 'zod';

export const searchGroupTypeSchema = z.enum([
  'clients',
  'engagements',
  'complianceClients',
  'complianceItems',
  'proposals',
  'invoices',
  'users',
  'goals',
  'tags',
]);

export const searchItemSchema = z.object({
  id: z.string(),
  title: z.string(),
  subtitle: z.string().optional(),
  href: z.string(),
});

export const searchGroupSchema = z.object({
  type: searchGroupTypeSchema,
  label: z.string(),
  total: z.number().int(),
  items: z.array(searchItemSchema),
});

export const searchResponseSchema = z.object({
  groups: z.array(searchGroupSchema),
});

export type SearchGroupType = z.infer<typeof searchGroupTypeSchema>;
export type SearchItem = z.infer<typeof searchItemSchema>;
export type SearchGroup = z.infer<typeof searchGroupSchema>;
export type SearchResponse = z.infer<typeof searchResponseSchema>;
